// extracted by mini-css-extract-plugin
export default {"layer-search":"LayerHomeSearch_layer-search__A7SZk","build-thinking-btn":"LayerHomeSearch_build-thinking-btn__89+Ek","layer-btn":"LayerHomeSearch_layer-btn__Ge85i"};